import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './session-transcript-summary.types';

export const sessionTranscriptSummarySelectors = {
  ...generateResourceSelectors<types.ISessionTranscriptSummary>((state) => state.resource.sessionTranscriptSummary),
};
